import React from 'react';
import CustomButton from '../../common_component/component/CustomButton';
import InputField from '../../common_component/component/InputField';
import CuDropdown from '../../common_component/component/CuDropdown';

const AdditionalTest = () => {
  const billingUnits = [
    { key: 1, value: 1, text: 'CHAKAN' },
    { key: 2, value: 2, text: 'RAVET' },
  ];
  const buttonStyle = {
    backgroundColor: '#C7EAC9',
    color: '#000000',
    border: 'none',
    borderRadius: '4px',
    padding: '13px',
    fontSize: '16px',
    width: '130px',
    cursor: 'pointer',
    margin: '6px',
    fontWeight: '400',
  };
  return (
    <div className="p-4 border border-gray-200 rounded shadow-sm">
      <div className="p-4 border border-gray-200 rounded shadow-sm">
        <div className="input-fields">
          <div className="input-field-2">
            <label htmlFor="dateInput">Date</label>
            <InputField id="dateInput" type={'date'} />
          </div>
          <div className="input-field-2">
            <label htmlFor="billingUnits">Name</label>
            <CuDropdown
              placeholder="Search"
              id="billingUnits"
              options={billingUnits}
            />
          </div>

          <div className="input-field-2">
            <label htmlFor="dateInput">Value</label>
            <InputField id="dateInput" type={'date'} />
          </div>
        </div>

        <div className="btn">
          <CustomButton
            style={{
              ...buttonStyle,
              backgroundColor: '#CDCDCD',
            }}
          >
            Cancel
          </CustomButton>

          <CustomButton style={buttonStyle}>Save</CustomButton>
        </div>
      </div>
    </div>
  );
};

export default AdditionalTest;
